import { createSlice } from '@reduxjs/toolkit';
import { fetchContestStats, fetchDailyContent } from '../../store/thunks/contestThunks';

const initialState = {
    stats: null,
    statsLoading: false,
    statsError: null,
    loading: false,
    error: null,
    dailyContent: null // Added dailyContent to initial state
};

const contestSlice = createSlice({
    name: 'contest',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchContestStats.pending, (state) => {
                state.statsLoading = true;
                state.statsError = null;
            })
            .addCase(fetchContestStats.fulfilled, (state, action) => {
                state.statsLoading = false;
                state.stats = action.payload;
                state.statsError = null;
            })
            .addCase(fetchContestStats.rejected, (state, action) => {
                state.statsLoading = false;
                state.statsError = action.payload;
            })
            .addCase(fetchDailyContent.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDailyContent.fulfilled, (state, action) => {
                state.loading = false;
                state.dailyContent = action.payload;
                state.error = null; // Added error null on success
            })
            .addCase(fetchDailyContent.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default contestSlice.reducer;